import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-custom-switch',
  template: `
    <div class="flex">
      @if (!showCustomView) {
        <label>{{ props.label }}</label>
      }
      <p-inputSwitch
        id="switch"
        class="ml-3"
        [formControl]="$any(formControl)"
      ></p-inputSwitch>
      @if (showCustomView) {
        <img
          [src]="'../../../../../../assets/images/' + imageURL"
          alt=""
          style="height: 20px"
          class="ml-2"
        />
        <p class="ml-2">{{ props.label }}</p>
      }
    </div>
  `
})
export class CustomSwitchComponent extends FieldType implements OnInit {
  showCustomView = false;
  imageURL = '';
  viewConfig!: {
    showView: boolean;
    imageURL: string;
  };

  ngOnInit(): void {
    this.viewConfig = this.props['viewConfig'];
    if (this.viewConfig) {
      this.showCustomView = this.viewConfig.showView;
      this.imageURL = this.viewConfig.imageURL;
    }
  }
}
